<template>
    <div class="updatePwd">
        <div class='list'>
            <div class='con'>
                <template v-if="seeList[0]">
                     <van-field v-model="oldpwd" type="text" label="" placeholder="旧密码" />
                     <img src='@/assets/img/mine/see.png' class="imgs" @click="setSee(0)">
                </template>
                <template v-else>
                     <van-field v-model="oldpwd" type="password" label="" placeholder="旧密码" />
                     <img src='@/assets/img/mine/unsee.png' class="imgs" @click="setSee(0)">
                </template>
            </div>
            
            <div class='con'>
                <template v-if="seeList[1]">
                    <van-field v-model="newpwd" type="text" label="" placeholder="新密码" />
                    <img src='@/assets/img/mine/see.png' class="imgs" @click="setSee(1)">
                </template>
                <template v-else>
                     <van-field v-model="newpwd" type="password" label="" placeholder="新密码" />
                     <img src='@/assets/img/mine/unsee.png' class="imgs" @click="setSee(1)">
                </template>
            </div>
            <div class='con'>
                <template v-if="seeList[2]">
                     <van-field v-model="newpwd2" type="text" label="" placeholder="确认密码" />
                     <img src='@/assets/img/mine/see.png' class="imgs" @click="setSee(2)">
                </template>
                <template v-else>
                     <van-field v-model="newpwd2" type="password" label="" placeholder="确认密码" />
                     <img src='@/assets/img/mine/unsee.png' class="imgs" @click="setSee(2)">
                </template>
            </div>
            <!-- <van-field v-model="newpwd2" type="password" label="" placeholder="确认密码" /> -->
            <!-- <p class="font12 red">{{text2}}</p> -->
            <div class="btn"> 
                 <div class="btn-primary" @click="handleClick" :disable="isclick">完成</div>
            </div> 
        </div>
       
    </div>
</template>
<script>
   import {modifyPassword} from '@/api/api.mine.js';
    export default {
        data() {
            return {
                oldpwd:'',
                newpwd:'',
                newpwd2:'',
                isclick:false,
                seeList:[false,false,false],
            }
        },
        methods:{
            hide(){
                this.$router.go(-1);
            },
            setSee(num){
                this.$set(this.seeList,num,!this.seeList[num])
                
            },
            handleClick(){
                // if(checkPwd(this.newpwd)){
                    if(this.oldpwd == ""){
                        this.$toast('请输入正确的旧密码');
                    }else if(this.newpwd == ""){
                        this.$toast('请输入正确的密码');
                    }else if(this.newpwd2 == ""){
                        this.$toast('请输入确认密码');
                    }else if(this.newpwd2 != this.newpwd){
                        this.$toast('请保持两次密码一致');
                    }else{
                        this.isclick=true;
                        modifyPassword({
                            newPwd:this.pubMethod.rsaEncrypt(this.newpwd),
                            sourcePwd:this.pubMethod.rsaEncrypt(this.oldpwd),
                            userId:this.loginUser.userId
                        }).then(data=>{
                            if(data.code=='00000'){
                                this.$toast('修改成功');
                                this.hide();
                            }else{
                                this.$toast(data.message);
                            }
                        })
                    }

             
            }
        }
    }
</script>
<style lang="scss" >
    .updatePwd{
        padding:.12rem;
        .list{
            position: relative;
            .red{
                color:#E84026;
                padding:0rem 0rem .12rem;
            }
            .con{
                margin-bottom: .12rem;
                position: relative;
                .van-field{
                    border-radius: 8px;
                    .van-field__control{
                        color:rgba(0,0,0,.6);
                        font-size: .16rem;
                    }
                    &::after{
                        border:none;
                    }
                }
                .imgs{
                    position:absolute;
                    right: .12rem;
                    top:.13rem;
                    width: .2rem;
                    height:.2rem;
                }
                
            }
        }
       .btn{
        margin-top: .48rem;
       }
    }
</style>
